module.exports = __webpack_public_path__ + "media/images/play-c7a564b5f125200ff595d86776e320e7.jpg";